// extracted by mini-css-extract-plugin
module.exports = {"Collapse":"Collapse_Collapse__1CIWQ","CollapseHeader":"Collapse_CollapseHeader__2ZU_a","HeaderIcon":"Collapse_HeaderIcon__1OVIX","CollapseBody":"Collapse_CollapseBody__2bQPk"};